import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { ContactsAddPersonComponent } from 'src/app/components/contacts-add-person/contacts-add-person.component';
import { ContactService } from 'src/app/services/contact.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AppGlobals } from 'src/app/app.globals';
import { HasChanges } from 'src/app/services/guards/unsaved-changes.guard';

@Component({
    selector: 'app-contacts-add-person.page',
    templateUrl: './contacts-add-person.page.html',
    styleUrls: ['./contacts-add-person.page.css'],
    providers: [ContactsAddPersonComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ContactsAddPersonComponent]
})
export class ContactsAddPersonPageComponent implements HasChanges {

  // The routed component is this thin wrapper, not the reusable form — canDeactivate
  // checks this class, so the guard's HasChanges contract is fulfilled by delegating
  // straight through to the form component's own state (see hasChangesGuard).
  @ViewChild(ContactsAddPersonComponent) addPersonForm: ContactsAddPersonComponent;

  get hasChanges(): boolean {
    return this.addPersonForm?.hasChanges ?? false;
  }
  set hasChanges(value: boolean) {
    if (this.addPersonForm) this.addPersonForm.hasChanges = value;
  }

  get isSavingChanges(): boolean {
    return this.addPersonForm?.isSavingChanges ?? false;
  }
  set isSavingChanges(value: boolean) {
    if (this.addPersonForm) this.addPersonForm.isSavingChanges = value;
  }

  constructor(private contactService: ContactService, private router: Router, private appGlobals: AppGlobals) {
/*     if (environment.isTestEnvironment === true) { */
      this.appGlobals.SetGlobalMenuIndex(6);
/*     } else {
      this.appGlobals.SetGlobalMenuIndex(4);
    } */
  }

  checkHasChanges(): void {
    this.addPersonForm?.checkHasChanges();
  }

  saveUnsavedChanges(): Observable<boolean> {
    return this.addPersonForm?.saveUnsavedChanges() ?? of(true);
  }

  handleAbort(e) {
    this.router.navigate([e.returnTo]);
  }

  handleSubmit(e) {
    this.router.navigate([e.returnTo])
  }
}
